// tslint:disable:max-line-length

import React from 'react';

export const ArrowUpSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="2,7.3 8,2 14,7.3 13.3,8 8.5,3.7 8.5,14 7.5,14 7.5,3.7 2.7,8" />
    </svg>
  );
};
